
import { Card, List  } from "@mui/material";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { AlarmSchemeUsageListItem } from "./AlarmSchemeUsageListItem";
import { AlarmSchemeListActionEnum } from "./AlarmSchemeListUtils";

export type AlarmSchemeUsageCardProps = {
    items: IeLynxObject[],
    onAction?: (action: AlarmSchemeListActionEnum, payload: IeLynxObject) => void,
};

export function AlarmSchemeUsageCard({
    items,
    onAction
}: AlarmSchemeUsageCardProps) {


    return (

        <Card variant="outlined"
            sx={{
            display: 'flex',
            flex: '1 1 auto',
            backgroundColor: "custom.background.cardContainer",
            marginLeft: 4,
            marginRight: 1,
            marginBottom: 1,
            padding: 1
        }}>

            <List sx={{
                paddingTop: 0,
                overflowX: "hidden",
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 auto'        
            }}>

                {items.sort((a, b) => (a.displayText ?? '').localeCompare(b.displayText ?? ''))?.map((o, index) =>

                    <AlarmSchemeUsageListItem 
                        key={index} 
                        item={o} 
                        onAction={(action, payload) => { onAction && onAction(action, payload)}} />

                )}                                      
            </List>

        </Card>    
    );
}





